export default __webpack_public_path__ + "static/image-order-summary-card-7a41df33d564a27629e357b1a2df6834.png";